import { render, staticRenderFns } from "./QrScan.vue?vue&type=template&id=06ed3434&scoped=true&"
import script from "./QrScan.vue?vue&type=script&lang=js&"
export * from "./QrScan.vue?vue&type=script&lang=js&"
import style0 from "./QrScan.vue?vue&type=style&index=0&id=06ed3434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed3434",
  null
  
)

export default component.exports